import { render, staticRenderFns } from "./OptIn.vue?vue&type=template&id=3cf607b0&"
import script from "./OptIn.vue?vue&type=script&lang=js&"
export * from "./OptIn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports